import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../lib/redux/hooks";
import { RightBar } from "../../../../../ui/organisms/rightBar";
import { NotifyStatusEditForms } from "./edit/forms";
import { NotifyStatusEditRight } from "./edit/right";
import { NotifyStatusForms } from "./forms";
import { NotifyStatusRight } from "./right";
import { GetAllNotificationStatus, resetGetAllNotificationStatusStatus, resetNotificationStatusUpdateStatus, setGetNotificationStatusByIdResponse, setNotificationStatusIdToUpdate, setNotificationStatusUpdateRequest } from "../slice";
import { useNavigate } from "react-router-dom";
import { NotificationStatusUpdateDTO } from "../dataservice/dto";

export function NotifyStatus() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const notificationState = useAppSelector(state => state.notification)
    const notificationStatusState = useAppSelector(state => state.notificationStatus)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        if (notificationState.notificationIdToUpdate === undefined)
            navigate('/notify')

        dispatch(GetAllNotificationStatus({
            itemsPerPage: 0,
            page: 0,
            notificationId: notificationState.notificationIdToUpdate
        }))
    }, [])

    useEffect(() => {
        if(notificationStatusState.getAllNotificationStatusStatus === 'successfully' &&
            notificationStatusState.getAllNotificationStatusResponse !== undefined && 
            notificationStatusState.getAllNotificationStatusResponse.data.length > 0
        ) {
            dispatch(resetGetAllNotificationStatusStatus())

            const data = notificationStatusState.getAllNotificationStatusResponse.data[0]
            console.log(data);
            
            dispatch(setGetNotificationStatusByIdResponse(data))
            dispatch(setNotificationStatusIdToUpdate(data.id))
            dispatch(setNotificationStatusUpdateRequest({
                notificationProtocolId: data.notificationProtocolId,
                expirationType: data.expirationType,
                certifiedSubsequentNotificationIssue: data.certifiedSubsequentNotificationIssued,
                certifiedNonCompliantNotification: data.certifiedNonCompliantNotification,
                certifiedOtherCauses: data.certifiedOtherCauses,
                certifiedNote: data.certifiedNote,
                notEmittedCertifiedId: data.notEmittedCertifiedId,
                documentIntegrationRequestId: data.documentIntegrationRequestId,
                variationCauses: data.variationCauses,
                note: data.note,
                notificationValidation: data.notificationValidation,
                validationDate: data.validationDate,
                motivation: data.motivation,
                additionalNote: data.additionalNote,
                officerId: data.officerId,
            } as NotificationStatusUpdateDTO))
        }

    }, [notificationStatusState.getAllNotificationStatusStatus])

    useEffect(() => {
        if(notificationStatusState.notificationStatusUpdateStatus === 'successfully') {
            dispatch(resetNotificationStatusUpdateStatus())
            dispatch(GetAllNotificationStatus({
                itemsPerPage: 0,
                page: 0,
                notificationId: notificationState.notificationIdToUpdate
            }))
            setShowSuccess(true)
        }
    }, [notificationStatusState.notificationStatusUpdateStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    return (
        <div style={{ display: 'flex', height: '100%', borderTopRightRadius: '20px', minHeight: window.innerHeight }}>
            <div style={{ flex: 0.6 }}>
                {
                    (showSuccess) &&

                    <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                        <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                            Dati salvati correttamente.
                        </span>
                    </div>
                }
                {
                    !notificationStatusState.onEdit ?
                        <NotifyStatusForms /> :
                        <NotifyStatusEditForms />
                }
            </div>

            <div className="bg-brandPrimary-100" style={{ flex: 0.4 }}>
                <RightBar>
                    {
                        !notificationStatusState.onEdit ?
                            <NotifyStatusRight /> :
                            <NotifyStatusEditRight />
                    }
                </RightBar>
            </div>
        </div>
    )
}